import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_CSOB } from "../domain";
import { ACTION_GET_CSOB_FORMS_METADATA } from "../GetCsobFormsMetadata";

import { csobHubApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_REMOVE_FORM = "REMOVE_FORM";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Respondent];

const removeForm = async (formId: string): Promise<void> => {
  const response = await csobHubApi.csobHubControllerRemoveForm(formId);

  return response.data;
};

export const useRemoveCsobForm = (
  user: UserProfileDto | null,
): {
  removeForm: UseMutateFunction<void, Error, string, unknown>;
  removeFormEnabled: boolean;
  isSuccessRemoveForm: boolean;
  isPendingRemoveForm: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_CSOB, ACTION_REMOVE_FORM],
    mutationFn: enabled ? removeForm : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_CSOB, ACTION_GET_CSOB_FORMS_METADATA],
      });
    },
  });

  return {
    removeForm: mutate,
    removeFormEnabled: enabled,
    isSuccessRemoveForm: isSuccess,
    isPendingRemoveForm: isPending,
  };
};
